// extracted by mini-css-extract-plugin
export var banner = "_gf-0";
export var closeButton = "_gf-2";
export var greenCheckmark = "_gf-3";
export var hereLink = "_gf-4";
export var titleIcon = "_gf-1";